// extracted by mini-css-extract-plugin
module.exports = {"container":"playerNewsPublish_container__e4RmO","bullet":"playerNewsPublish_bullet__DVgjf","source":"playerNewsPublish_source__x6MmR"};